module.exports = __webpack_public_path__ + "img/partenaire.34c3cbb6.png";